var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "format-settings"
  }, [_vm._m(0), _c('section', {
    staticClass: "format-section"
  }, [_vm._m(1), _c('div', {
    staticClass: "measure-grid"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Largura")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "5",
      "max": "300",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.label.largura_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('etiqueta.largura_mm', $event.target.value);
      }
    }
  }), _vm._m(2)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Altura")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "5",
      "max": "300",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.label.altura_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('etiqueta.altura_mm', $event.target.value);
      }
    }
  }), _vm._m(3)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Área segura")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "20",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.label.padding_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('etiqueta.padding_mm', $event.target.value);
      }
    }
  }), _vm._m(4)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Borda")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.label.borda_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('etiqueta.borda_mm', $event.target.value);
      }
    }
  }), _vm._m(5)])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 form-group mb-0"
  }, [_c('label', [_vm._v("Fundo")]), _c('div', {
    staticClass: "color-input"
  }, [_c('input', {
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": _vm.label.fundo || '#FFFFFF'
    },
    on: {
      "input": function input($event) {
        _vm.set('etiqueta.fundo', $event.target.value.toUpperCase());
      }
    }
  }), _c('span', [_vm._v(_vm._s(_vm.label.fundo || "#FFFFFF"))])])]), _c('div', {
    staticClass: "col-6 form-group mb-0"
  }, [_c('label', [_vm._v("Cantos arredondados")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "20",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.label.cantos_arredondados_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('etiqueta.cantos_arredondados_mm', $event.target.value);
      }
    }
  }), _vm._m(6)])])])]), _c('section', {
    staticClass: "format-section"
  }, [_vm._m(7), _c('div', {
    staticClass: "auto-roll-setting"
  }, [_vm._m(8), _c('b-form-checkbox', {
    attrs: {
      "checked": _vm.autoFitRoll,
      "switch": "",
      "aria-label": "Ajustar rolo automaticamente"
    },
    on: {
      "change": _vm.setAutoFitRoll
    }
  })], 1), _c('div', {
    staticClass: "measure-grid"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Largura")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "10",
      "max": "500",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.page.largura_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('pagina.largura_mm', $event.target.value);
      }
    }
  }), _vm._m(9)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Altura")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "10",
      "max": "500",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.page.altura_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('pagina.altura_mm', $event.target.value);
      }
    }
  }), _vm._m(10)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Colunas")]), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "10",
      "step": "1"
    },
    domProps: {
      "value": _vm.page.colunas
    },
    on: {
      "input": function input($event) {
        return _vm.setInteger('pagina.colunas', $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Linhas")]), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100",
      "step": "1"
    },
    domProps: {
      "value": _vm.page.linhas
    },
    on: {
      "input": function input($event) {
        return _vm.setInteger('pagina.linhas', $event.target.value);
      }
    }
  })])]), _c('button', {
    staticClass: "advanced-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.advanced = !_vm.advanced;
      }
    }
  }, [_c('span', [_vm._v("Margens e espaçamentos")]), _c('i', {
    class: _vm.advanced ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
  })]), _vm.advanced ? _c('div', {
    staticClass: "advanced-box"
  }, [_c('span', {
    staticClass: "advanced-label"
  }, [_vm._v("Margens")]), _c('div', {
    staticClass: "measure-grid"
  }, _vm._l(_vm.margins, function (margin) {
    return _c('div', {
      key: margin.key,
      staticClass: "form-group"
    }, [_c('label', [_vm._v(_vm._s(margin.label))]), _c('div', {
      staticClass: "input-group input-group-sm"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100",
        "step": "0.1"
      },
      domProps: {
        "value": _vm.page[margin.key]
      },
      on: {
        "input": function input($event) {
          return _vm.setNumber("pagina.".concat(margin.key), $event.target.value);
        }
      }
    }), _vm._m(11, true)])]);
  }), 0), _c('span', {
    staticClass: "advanced-label"
  }, [_vm._v("Entre etiquetas")]), _c('div', {
    staticClass: "measure-grid mb-0"
  }, [_c('div', {
    staticClass: "form-group mb-0"
  }, [_c('label', [_vm._v("Horizontal")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "50",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.page.espacamento_horizontal_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('pagina.espacamento_horizontal_mm', $event.target.value);
      }
    }
  }), _vm._m(12)])]), _c('div', {
    staticClass: "form-group mb-0"
  }, [_c('label', [_vm._v("Vertical")]), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "50",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.page.espacamento_vertical_mm
    },
    on: {
      "input": function input($event) {
        return _vm.setNumber('pagina.espacamento_vertical_mm', $event.target.value);
      }
    }
  }), _vm._m(13)])])])]) : _vm._e()]), _c('div', {
    staticClass: "fit-summary",
    class: _vm.fitsPage ? 'fits' : 'overflow'
  }, [_c('i', {
    class: _vm.fitsPage ? 'fas fa-check-circle' : 'fas fa-exclamation-triangle'
  }), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.fitsPage ? "Distribuição cabe na página" : "Distribuição ultrapassa a página"))]), _c('small', [_vm._v(_vm._s(_vm.totalLabels) + " etiqueta" + _vm._s(_vm.totalLabels === 1 ? "" : "s") + " por página · uso de " + _vm._s(_vm.usedWidth) + " × " + _vm._s(_vm.usedHeight) + " mm")])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "format-heading"
  }, [_c('span', {
    staticClass: "etq-panel-kicker"
  }, [_vm._v("Medidas físicas")]), _c('h5', [_vm._v("Formato e página")]), _c('p', [_vm._v("Use as medidas indicadas pelo fabricante do rolo ou da folha.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "format-section-title"
  }, [_c('span', {
    staticClass: "format-section-icon"
  }, [_c('i', {
    staticClass: "fas fa-tag"
  })]), _c('div', [_c('strong', [_vm._v("Etiqueta")]), _c('small', [_vm._v("Tamanho de cada unidade")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "format-section-title"
  }, [_c('span', {
    staticClass: "format-section-icon blue"
  }, [_c('i', {
    staticClass: "far fa-file-alt"
  })]), _c('div', [_c('strong', [_vm._v("Página ou rolo")]), _c('small', [_vm._v("Distribuição para impressão")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('strong', [_vm._v("Ajustar rolo automaticamente")]), _c('small', [_vm._v("Mantém a página no tamanho exato da distribuição de etiquetas.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("mm")])]);
}];
export { render, staticRenderFns };